/** Domain, deren Mitarbeitende sich NICHT mit ihrer E-Mail-Adresse anmelden. */
const INTERNAL_MAIL_DOMAIN = "@value-ag.de";

/** Präfix des internen Anmeldenamen-Schemas. */
const LOGIN_PREFIX = "value.";

/** Die Anmeldenamen sind transliteriert (value.klaus.mueller, nicht value.klaus.müller). */
const TRANSLITERATIONS: [RegExp, string][] = [
    [/ä/g, "ae"],
    [/ö/g, "oe"],
    [/ü/g, "ue"],
    [/ß/g, "ss"],
];

/**
 * Schlägt zu einer als Anmeldename eingegebenen VALUE-AG-Mailadresse den passenden
 * Anmeldenamen vor — oder null, wenn die Eingabe keine solche Adresse enthält.
 *
 * Hintergrund: Es gibt zwei Namensschemata (`value.vorname.nachname` und, bei externen
 * Kunden, die Mailadresse selbst). Mitarbeitende der VALUE AG tippen ihre Mailadresse,
 * ihr Anmeldename ist aber `value.vorname.nachname` — in den LIVE-Logs waren das über
 * eine Woche 19 Fehlversuche. Die Fehlermeldung ist dieselbe wie bei einem falschen
 * Passwort, der Unterschied also nicht erkennbar (das ist gegen Benutzer-Enumeration
 * bewusst so).
 *
 * **Diese Funktion darf niemals an eine Abfrage des Datenbestands gekoppelt werden.**
 * Sie ist ausschließlich eine Funktion der Eingabe des Benutzers und verrät damit
 * nichts: eine `@value-ag.de`-Adresse ist per Namensschema nie ein Anmeldename (0 von
 * 690 Konten). Würde der Hinweis dagegen davon abhängen, ob der vorgeschlagene Name
 * tatsächlich existiert, wäre er ein Orakel für die Existenz von Konten.
 *
 * Der Vorschlag ist bewusst nur ein Vorschlag: bei einigen Konten weicht der
 * Anmeldename von der Regel ab.
 *
 * @param enteredLoginName der eingegebene Anmeldename
 * @return vorgeschlagener Anmeldename, oder null
 */
export function suggestInternalLoginName(enteredLoginName: string | null | undefined): string | null {
    if (!enteredLoginName) return null;
    const entered = enteredLoginName.trim().toLowerCase();
    if (!entered.includes(INTERNAL_MAIL_DOMAIN)) return null;

    const localPart = entered.slice(0, entered.indexOf("@"));
    const name = TRANSLITERATIONS.reduce(
        (current, [pattern, replacement]) => current.replace(pattern, replacement),
        localPart,
    )
        // Alles, was kein Namensbestandteil ist (Unterstrich, Leerzeichen, ...), trennt wie ein Punkt
        .replace(/[^a-z0-9]+/g, ".")
        .replace(/^\.+|\.+$/g, "");
    if (!name) return null;

    return name.startsWith(LOGIN_PREFIX) ? name : LOGIN_PREFIX + name;
}
